module.exports = __webpack_public_path__ + "static/img/gi.0824d9db.svg";